import { encodeSlug } from './encode-slug';
import { prefixLocale } from './prefix-locale';

export function buildEnglishIqResultPath(shareId: string, locale?: string): string {
  return prefixLocale(`/english-iq/r/${encodeSlug(shareId)}`, locale);
}
